import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export const ADMIN_SITE_URLS_QUERY_KEY = 'admin/site/urls/<accountId>';

/** Mirrors Levitate.Api.Models.Websites.SiteUrlsResponse. Published and platform URLs are null until it is published. */
export interface ISiteUrls {
	previewUrl: string;
	publishedUrl?: string | null;
	platformUrl?: string | null;
}

/** The account's Levitate Sites URLs, or null when it has no Levitate site yet. */
export function useAdminSiteUrlsQuery({ accountId, enabled = true }: { accountId: string; enabled?: boolean }) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryKey: [ADMIN_SITE_URLS_QUERY_KEY, accountId],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ISiteUrls>({
				path: Api.ImpersonationBroker.composeApiUrl({
					impersonationContext: { account: { id: accountId } },
					urlPath: 'site/urls',
				}),
				method: 'GET',
				throwOn404: false,
			}),
		meta: {
			toastErrorMessage: 'Failed to load the site preview link.',
		},
	});
}
